export default "__VITE_ASSET__f853719e__"